import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent } from '../../../base.component';
import { AnalyticsStore } from '../../analytics-store.service';

@Component({
  selector: 'app-keywords-top-25',
  templateUrl: './keywords-top-25.component.html',
  styleUrls: ['./keywords-top-25.component.css']
})
export class KeywordsTop25Component extends BaseComponent implements OnInit {

  public keywordsTop25: number;
  public keywordsTop25ChangePercentage: string;
  public showChange: boolean;

  constructor(private analytics: AnalyticsStore) {
    super();
  }

  ngOnInit() {
    this.analytics.data
      .pipe(
        takeUntil(this.unsubscribe)
      )
      .subscribe(x => {
        if (!x) {
          return;
        }

        this.keywordsTop25 = x.keywordsTop25;
        this.keywordsTop25ChangePercentage = `${x.keywordsTop25ChangePercentage}%`;
        this.showChange = x.keywordsTop25ChangePercentage > 0;
      });
  }
}
